module.exports = __webpack_public_path__ + "assets/img/Logo-Mexxico.cd806914.png";